

export enum DeploymentPrefix {
    Dev = "dev",
    Demo = "demo",
    Prod = "app",
    Custom = "custom"
}